export default (axios) => ({
  getSelectList(params) {
    return axios({
      method: 'get',
      url: '/productLanguage/selectList',
      params
    })
  },
  // getProductVideo(params) {
  //   return axios({
  //     method: 'get',
  //     url: '/productVideo/getByWebsite',
  //     params
  //   })
  // }
  getProductVideo(params) {
    return axios.get(`/country/${params}`)
  },
  // webinarcenter 页面接口
  getWebinarcenter(params) {
    return axios({
      method: 'get',
      url: '/activity',
      params
    })
  },
  // productservice 页面接口
  getProductList(params) {
    return axios({
      method: 'get',
      url: '/productTable/getOverseas',
      params
    })
  },
  // faqTable
  getFaqTableList(params) {
    return axios({
      method: 'get',
      url: '/faqTable/selectById',
      params
    })
  },
  //  视频中心页面接口
  getVideoCenter(path) {
    return axios.get(`/productVideo/getByWebsite${path}`)
  },
  // 获取感兴趣产品列表
  getInterestedProduct(params) {
    return axios({
      method: 'get',
      url: '/productLanguage/selectList',
      params
    })
  },
  // websiteDetail 详情页
  getWebsiteDetail(params) {
    return axios({
      method: 'get',
      url: '/activity/detail',
      params
    })
  }
  //
  // toSubmitForm(data) {
  //   return axios.post('/leaveMessageRequest/add', {
  //     data
  //   })
  // }
})
